module.exports = __webpack_public_path__ + "static/TestSetupboerderij-8a0beb6a65ea1faedfb75edc983e776a.jpg";